import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Детски чаршафи от ранфорс – 100% памук | GoToBed',
  description:
    'Детски чаршафи от ранфорс, 100% памук. Размери 115/155, 120/200, 150/220, 200/240. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Детски чаршафи от ранфорс
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Детски чаршафи от ранфорс – 100% памук и богат избор от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Детските чаршафи от ранфорс са изработени от 100% памук и са отличен избор за детско легло
          и ежедневно използване. Ранфорсът е плътна и издръжлива памучна материя, която позволява
          на кожата да диша и осигурява комфортен сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите се изработват по поръчка, което ни позволява да предложим богат избор от размери
          за бебешки и детски матраци – например 60/120, 70/140, 82/190 и 90/200. Те се изработват в
          по-големи размери, за да покриват удобно матрака и да могат лесно да се подпъхват.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiCharshafiRanfors />;
}

function SeoBodyDetskiCharshafiRanfors() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Детски чаршафи от ранфорс за детско легло – 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Детски чаршафи от ранфорс за детско легло – 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Детските чаршафи от ранфорс за детско легло са отличен избор за родители, които търсят
        качествено, удобно и издръжливо спално бельо за детско легло. Ранфорсът е 100% памучен плат,
        който се отличава със здравина, добра дишаемост и приятна на допир материя.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете детски чаршафи ранфорс, подходящи за различни размери детски
        легла и матраци. Памучната тъкан е удобна за ежедневна употреба и осигурява комфортен сън за
        детето.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички чаршафи се изработват внимателно от висококачествени памучни материи със сертификат
        OEKO-TEX Standard 100, което гарантира безопасност и високо качество на текстила.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        За да създадете пълен комплект детско спално бельо, можете да комбинирате чаршафа с
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски калъфки ранфорс
        </Typography>
      </Box>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        които се изработват от същия висококачествен памучен плат.
      </Typography>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Размери детски чаршафи от ранфорс за детско легло */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Размери детски чаршафи от ранфорс за детско легло
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашите продукти е голямото разнообразие от размери, което
          позволява лесно да намерите подходящ чаршаф за детско легло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме детски чаршафи в размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '115/155',
            '115/180',
            '110/210',
            '120/200',
            '120/220',
            '130/220',
            '140/220',
            '140/240',
            '150/220',
            '150/240',
            '160/220',
            '160/240',
            '170/240',
            '180/220',
            '180/240',
            '200/220',
            '200/240',
            '220/240'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Благодарение на този богат избор можете лесно да намерите подходящ памучен чаршаф за
          детско легло или детски матрак.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите и други материи, можете да разгледате и нашите
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-charshafi/2/7/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски чаршафи памучен сатен
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          които предлагат по-гладка и фина структура на плата.
        </Typography>

        {/* H2: Какво представлява платът ранфорс? */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какво представлява платът ранфорс?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ранфорсът е плътна памучна тъкан, изработена от 100% естествени влакна. Той е много
          популярен за спално бельо, защото съчетава комфорт, издръжливост и добра дишаемост.
        </Typography>
        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Основни предимства на ранфорса
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; 100% памук',
            '&#10004; дишащ и приятен на допир плат',
            '&#10004; устойчивост при пране',
            '&#10004; комфорт през всички сезони',
            '&#10004; подходящ за детско спално бельо'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Детските чаршафи от ранфорс са практичен избор за родители, които търсят здрав и удобен
          памучен чаршаф за детско легло.
        </Typography>

        {/* H2: Предимства на нашите детски чаршафи ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите детски чаршафи ранфорс
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '&#10004; изработени от 100% памук ранфорс',
            '&#10004; дишащ и комфортен плат',
            '&#10004; подходящи за детска кожа',
            '&#10004; голям избор от размери',
            '&#10004; устойчиви при многократно пране',
            '&#10004; произведени в България',
            '&#10004; сертификат OEKO-TEX Standard 100 на платовете'
          ].map((item) => (
            <Typography
              key={item}
              variant="body1"
              sx={{ color: 'text.secondary' }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За пълен комплект спално бельо можете да комбинирате чаршафа и с
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски пликове за завивки ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-kalufki/2/8/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            детски калъфки за възглавници ранфорс
          </Typography>
        </Box>

        {/* H2: Свиваемост на памучния плат */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучния плат
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тъй като чаршафите са изработени от 100% памук, е възможна естествена свиваемост около
          4–5% след първите пранета. Това е нормално свойство на памучните материи и е характерно за
          всички изделия от естествен памук.
        </Typography>

        {/* H2: Популярни размери детски чаршафи ранфорс */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери детски чаршафи ранфорс
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'чаршаф за детско легло 115/155 (115х155) см',
            'чаршаф за детско легло 115/180 (115х180) см',
            'чаршаф за детско легло 120/200 (120х200) см',
            'чаршаф за детско легло 150/220 (150х220) см',
            'чаршаф за детско легло 160/240 (160х240) см',
            'чаршаф за детско легло 200/240 (200х240) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички детски чаршафи се изработват индивидуално след направена поръчка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за детски чаршафи ранфорс
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер детски чаршаф?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете подходящ чаршаф за детско легло, измерете ширината и дължината на матрака
            и изберете чаршаф със същия или близък размер. В нашия магазин ще откриете детски
            чаршафи в много различни размери, което позволява лесно да намерите подходящия вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящ ли е ранфорсът за детско спално бельо?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Ранфорсът е 100% памучен плат, който е дишащ, здрав и приятен на допир. Това го
            прави много подходящ за детско спално бельо.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се детските чаршафи от ранфорс след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от естествен памук, и чаршафите от ранфорс могат да имат естествена
            свиваемост около 4–5% след първите пранета.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите за различни размери детски легла?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Благодарение на богатия избор от размери можете лесно да намерите подходящ чаршаф за
            детско легло и различни детски матраци.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват детските чаршафи?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички чаршафи се изработват в България, специално за всяка поръчка и според избрания
            размер.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
